// extracted by mini-css-extract-plugin
export default {"download":"D6zfw","failureListTable":"X2aMb","headerDesc":"MJysH"};